import { render, staticRenderFns } from "./TableV2.vue?vue&type=template&id=572244f0&scoped=true"
import script from "./TableV2.vue?vue&type=script&lang=js"
export * from "./TableV2.vue?vue&type=script&lang=js"
import style0 from "./TableV2.vue?vue&type=style&index=0&id=572244f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572244f0",
  null
  
)

export default component.exports